import {
  FETCH_ABSENT_LAST5_REQUEST,
  FETCH_ABSENT_LAST5_SUCCESS,
  FETCH_ABSENT_LAST5_FAILURE,
} from "../constants/AbsentLast5Constants";

import AbsentLast5Service from "../service/AbsentLast3Service";

export const fetchAbsentLast5 = (sdate, edate) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_ABSENT_LAST5_REQUEST });

    const data = await AbsentLast5Service.getAll(sdate, edate);

    dispatch({
      type: FETCH_ABSENT_LAST5_SUCCESS,
      payload: data,
    });
    
    console.log("Data loaded successfully:", data);
  } catch (error) {
    console.error("Error in fetchAbsentLast5 action:", error);
    dispatch({
      type: FETCH_ABSENT_LAST5_FAILURE,
      payload: error.response?.data?.message || error.message || "Failed to fetch absent last 5 data",
    });
  }
};